import { GymTypes } from 'fitbeat.models';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { ExerciseSelection } from '../../entities/workout/exerciseselection';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class BagContactFilter implements IExerciseSelectionFilter {
    public description: string = 'Removes bag exercises if not boxing zone';
    public name: string = 'BagContactFilter';

    public filter(
        inputExercises: Exercise[],
        exerciseSelection: ExerciseSelection,
        userWorkoutSettings: WorkoutSettings,
        selectedZoneExercisesSoFar: Exercise[],
        workoutStartDate: Date,
        gymType: GymTypes,
    ): Exercise[] {
        const allowBagContactSetting = userWorkoutSettings.allowBagContact;
        return inputExercises.filter((e) => allowBagContactSetting ? e.bagContact : !e.bagContact);
    }
}
